<template>
  <div id="detail">
    <!-- 订单支付成功 -->
    <header>
      <img src="@/static/images/other/chenggong.png" alt="" class="chenggong" />
      <p class="big-title">订单支付成功!</p>
      <p class="tip">
        您可以在我的订单中查询详情。
      </p>
    </header>
    <div class="btn">
      <mt-button
        size="large"
        type="primary"
        @click="changeRouter('/orderList/1')"
        >查看订单</mt-button
      >
      <mt-button size="large" type="default" @click="changeRouter('/')"
        >返回首页</mt-button
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      goodsId: "",
    };
  },
  mounted() {
    this.goodsId = this.$route.params.id;
  },
  methods: {
    seeOrderDetail() {
      this.changeRouter('/orderDetail/1/'+this.goodsId)
    },
  },
};
</script>

<style lang="less" scoped>
#detail {
  padding-top: 82px;
  padding-bottom: 50px;
  header {
    text-align: center;
    .chenggong {
      width: 189px;
      height: 158px;
    }
    .big-title {
      font-family: PingFang-SC-Heavy;
      font-size: 30px;
      line-height: 36px;
      color: #66906a;
      padding-bottom: 20px;
      font-weight: bold;
    }
    .tip {
      font-family: PingFang-SC-Medium;
      font-size: 24px;
      line-height: 35px;
      color: #878787;
    }
  }
  .result {
    padding-top: 68px;
    padding-bottom: 73px;
    table {
      margin: 0 auto;
      width: 626px;
      height: 203px;
      background-color: #ffffff;
      border: solid 1px #1fbe6e;
      text-align: center;
      .head {
        font-family: PingFang-SC-Medium;
        font-size: 24px;
        color: #067e42;
      }
      td {
        height: 66px;
      }
    }
    .code {
      font-family: PingFang-SC-Bold;
      font-size: 34px;
      font-weight: bold;
      text-align: center;
    }
  }
  .btn {
    margin: 150px auto 0;
    width: 611px;
    .mint-button--default {
      margin-top: 40px;
    }
  }
}
</style>
